var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M5.375 15.438c-.379-.379-.413-.97-.104-1.388l.104-.12L10.305 9l-4.93-4.93c-.379-.379-.413-.971-.104-1.388l.104-.12c.378-.378.97-.413 1.387-.103l.12.103 5.684 5.684c.378.379.413.97.103 1.388l-.103.12-5.684 5.684c-.416.416-1.091.416-1.507 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.ce74fefee8d753d7f21d471d9f0dbc5b.svg";
export { ForwardRef as ReactComponent };